<template>
  <div>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer ce netlink ?" style="z-index: 54000 !important;">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="acceptDelete()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="declineDelete()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup :active.sync="showNetlinkPopup" title="Modification d'un Netlink" style="z-index: 54000 !important;">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Lien acheté</label>
			<div class="flex">
				<vs-input
					:style="styleValidator('urlBought')"
					@change="validateOne(modifiedNetlink.urlBought, 'urlBought')"
					class="w-full"
					placeholder="Lien acheté"
					v-model="modifiedNetlink.urlBought"
				/>
				<vx-tooltip v-if="validators['urlBought'] && validators['urlBought'].errText !== ''" :text="errText('urlBought')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
		</div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Landing page</label>
			<div class="flex">
				<vs-input
					:style="styleValidator('landingPage')"
					@change="validateOne(modifiedNetlink.landingPage, 'landingPaget')"
					class="w-full"
					placeholder="Landing page"
					v-model="modifiedNetlink.landingPage"
				/>
				<vx-tooltip v-if="validators['landingPage'] && validators['landingPage'].errText !== ''" :text="errText('landingPage')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.status"
					class="w-full select-medium mr-2"
					placeholder="Statut"
					:style="styleValidator('status')"
					@change="validateOne(modifiedNetlink.status, 'status')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in netlinkStatus"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['status'] && validators['status'].errText !== ''" :text="errText('status')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
      </div>
      <div class="vx-row mt-2">
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type ancre</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.anchorType"
					class="w-full select-medium mr-2"
					placeholder="Type ancre"
					:style="styleValidator('anchorType')"
					@change="validateOne(modifiedNetlink.anchorType, 'anchorType')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in anchorTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['anchorType'] && validators['anchorType'].errText !== ''" :text="errText('anchorType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type lien</label>
			<div class="flex">
				<vs-select
					v-if="isFromNDD == 0"
					autocomplete
					v-model="modifiedNetlink.linkType"
					class="w-full select-medium mr-2"
					placeholder="Type lien"
					:style="styleValidator('linkType')"
					@change="validateOne(modifiedNetlink.linkType, 'linkType')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in linkTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['linkType'] && validators['linkType'].errText !== ''" :text="errText('linkType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
        </div>
        <div v-if="isFromNDD == 0" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Prix</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="modifiedNetlink.price"
					:style="styleValidator('price')"
					@change="validateOne(modifiedNetlink.price, 'price')"
				/>
				<vx-tooltip v-if="validators['price'] && validators['price'].errText !== ''" :text="errText('price')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
      	<div v-if="modifiedNetlink.linkType == 1" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Renouvellement</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="modifiedNetlink.renew_duration"
					class="w-full select-medium mr-2"
					:style="styleValidator('renew_duration')"
					@change="validateOne(modifiedNetlink.renew_duration, 'renew_duration')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in renewDurations"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['renew_duration'] && validators['renew_duration'].errText !== ''" :text="errText('renew_duration')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()">Enregistrer Netlink</vs-button>
        </div>
      </div>
    </vs-popup>




    <div v-if="netlink_list.length > 0" class="vx-row center_div t-border">
      <vs-table :data="netlink_list" style="overflow: auto;">
        <template slot="header">
            <h3>
            Netlinking
            </h3>
        </template>
        <template slot="thead">
          <vs-th>Lien acheté</vs-th>
          <vs-th>Landing page</vs-th>
          <!-- <vs-th>Statut</vs-th> -->
          <vs-th>Type ancre</vs-th>
          <vs-th v-if="!isFromNDD">Type lien</vs-th>
          <vs-th v-if="!isFromNDD">Durée</vs-th>
          <vs-th v-if="!isFromNDD">Prix</vs-th>
          <vs-th v-if="isFromNDD">Nom de domaine</vs-th>
          <!-- <vs-th v-if="showNetlinkBuyer">Acheté par</vs-th> -->
          <vs-th></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope={data}>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="tr.urlBought">{{ tr.urlBought }}</vs-td>
            <vs-td :data="tr.landingPage">{{ tr.landingPage }}
            </vs-td>
            <!-- <vs-td :data="tr.status">{{ getNetlinkStatus(tr.status) }}</vs-td> -->
            <vs-td :data="tr.anchor_type">{{ getNetlinkAnchorType(tr.anchorType) }}</vs-td>
            <vs-td v-if="!isFromNDD" :data="tr.linkType">{{ getNetlinkTypeName(tr.linkType) }}</vs-td>
            <vs-td v-if="!isFromNDD" :data="tr.renew_duration">{{ getNetlinkRenewDuration(tr.renew_duration) }}</vs-td>
            <vs-td v-if="!isFromNDD" :data="tr.price">{{ tr.price + '€' }}</vs-td>
            <vs-td v-if="isFromNDD" :data="tr.dns_id">{{ getDnsName(tr.dns_id) }}</vs-td>
            <!-- <vs-td :data="tr.society_id" v-if="showNetlinkBuyer">{{ tr.purchase_id ? "Rankwell" : "Client" }}</vs-td> -->
            <vs-td><vs-button color="primary" @click="modifyNetlink(indextr)">Modifier</vs-button></vs-td>
            <vs-td><vs-button color="primary" @click="displayValidationPopup(indextr)">Supprimer</vs-button></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div v-if="showNewNetlink" class="vx-row center_div" style="display: flex; flex-wrap: nowrap;">
      	<div class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Lien acheté</label>
			<div class="flex">
				<vs-input
					:style="styleValidator('newUrlBought')"
					@change="validateOne(newUrlBought, 'newUrlBought')"
					class="w-full"
					placeholder="Lien acheté"
					v-model="newUrlBought"
				/>
				<vx-tooltip v-if="validators['newUrlBought'] && validators['newUrlBought'].errText !== ''" :text="errText('newUrlBought')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Landing page</label>
			<div class="flex">
				<vs-input
					:style="styleValidator('newLandingPage')"
					@change="validateOne(newLandingPage, 'newLandingPage')"
					class="w-full"
					placeholder="Landing page"
					v-model="newLandingPage"
				/>
				<vx-tooltip v-if="validators['newLandingPage'] && validators['newLandingPage'].errText !== ''" :text="errText('newLandingPage')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Statut</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newStatus"
					class="w-full select-medium mr-2"
					placeholder="Statut"
					:style="styleValidator('newStatus')"
					@change="validateOne(newStatus, 'newStatus')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in netlinkStatus"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newStatus'] && validators['newStatus'].errText !== ''" :text="errText('newStatus')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type ancre</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newAnchorType"
					class="w-full select-medium mr-2"
					placeholder="Type ancre"
					:style="styleValidator('newAnchorType')"
					@change="validateOne(newAnchorType, 'newAnchorType')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in anchorTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newAnchorType'] && validators['newAnchorType'].errText !== ''" :text="errText('newAnchorType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div v-if="isFromNDD == 0" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Type lien</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newLinkType"
					class="w-full select-medium mr-2"
					placeholder="Type lien"
					:style="styleValidator('newLinkType')"
					@change="validateOne(newLinkType, 'newLinkType')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.name"
						v-for="(item, index) in linkTypes"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newLinkType'] && validators['newLinkType'].errText !== ''" :text="errText('newLinkType')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div v-if="isFromNDD == 0" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Prix</label>
			<div class="flex">
				<vs-input
					class="w-full"
					v-model="newLinkPrice"
					:style="styleValidator('newLinkPrice')"
					@change="validateOne(newLinkPrice, 'newLinkPrice')"
				/>
				<vx-tooltip v-if="validators['newLinkPrice'] && validators['newLinkPrice'].errText !== ''" :text="errText('newLinkPrice')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div v-if="isRecurringLink(newLinkType)" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Renouvellement</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newRenewDuration"
					class="w-full select-medium mr-2"
					:style="styleValidator('newRenewDuration')"
					@change="validateOne(newRenewDuration, 'newRenewDuration')"
				>
					<vs-select-item
						:key="index"
						:value="item.value"
						:text="item.text"
						v-for="(item, index) in renewDurations"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newRenewDuration'] && validators['newRenewDuration'].errText !== ''" :text="errText('newRenewDuration')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      	<div v-if="isFromNDD" class="vx-col" style="white-space: nowrap;">
		  	<label for="" class="vs-select--label">Nom de domaine</label>
			<div class="flex">
				<vs-select
					autocomplete
					v-model="newNetlinkDns"
					class="w-full select-medium mr-2"
					:style="styleValidator('newNetlinkDns')"
					@change="validateOne(newNetlinkDns, 'newNetlinkDns')"
				>
					<vs-select-item
						:key="index"
						:value="item.id"
						:text="item.host"
						v-for="(item, index) in dns"
						class="w-full"
					/>
				</vs-select>
				<vx-tooltip v-if="validators['newNetlinkDns'] && validators['newNetlinkDns'].errText !== ''" :text="errText('newNetlinkDns')" class="ml-3" style="display: inline-block;">
					<vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
				</vx-tooltip>
			</div>
      	</div>

      <div class="vx-col" style="white-space: nowrap;">
        <vs-button color="primary" class="mt-2" @click="addNetLink()">Ajouter Netlink</vs-button>
      </div>
    </div>
    <div class="vx-row center_div">
      <vs-spacer />
      <div class="vx-col">
        <strong>Prix Total : {{ totalLinkPrice }}€</strong>
      </div>
    </div>
    <div v-if="!showNewNetlink" class="vx-row center_div">
      <vs-button
        class="float-right"
        radius
        color="primary"
        type="filled"
        icon-pack="feather"
        icon="icon-plus"
        @click="showNewNetlinkForm"
      ></vs-button>
    </div>

  </div>
</template>
<script>
// import Vue from 'vue'
import Netlink from "@/entities/Netlink";
// import NetlinkModifyPopup from "@/components/popups/NetlinkModifyPopup"
import store from "@/store/store";
import Validator from "@/entities/Validator";
import validatorMixin from "@/mixins/validatorMixin";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "NewNetlinkPopupTable",
	components: [VxTooltip],
	mixins: [dbFieldConvertor, utilsMixin, validatorMixin],
	props: {
		purchaseId: Number,
		societyId: Number,
		linkType: Number,
		showNetlinkBuyer: Boolean,
		isFromNDD: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			netlink: Netlink.getFormFields(),
			modifiedNetlink: Netlink.getFormFields(),
			modifiedNetlinkIndex: null,
			netlink_list: [],
			netlinkStatus: [
				{text: "Actif", value: 0},
				{text: "En\u00a0attente", value: 1},
				{text: "Refusé", value: 2},
				{text: "Terminé", value: 3},
				{text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4},
				{text: "Annulé", value: 5}
			],
			anchorTypes: [
				{text: "Brand et Générique", value: 0},
				{text: " Semi optimisée", value: 1},
				{text: "Générique", value: 2},
				{text: "Non optimisée", value: 3},
				{text: "Optimisée", value: 4},
			],
			linkTypes: [],
			renewDurations: [
				{text: "A\u00a0vie", value: "0"},
				{text: "Mensuel", value: "1"},
				{text: "Annuel", value: "12"},
			],
			newNetlinkDns: null,
			newUrlBought: "",
			newLandingPage: "",
			newAnchorType: null,
			newLinkType: null,
			newLinkPrice: 0,
			newRenewDuration: "0",
			newStatus: null,
			totalLinkPrice: 0,
			showNetlinkPopup: false,
			showNewNetlink: true,
			showValidationPopup: false,
			selectedNetlink: null,
			totalPurchasePrice: 0,
			// Validator Objects
			NetlinkValidationObjects: {
				urlBoughtValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
				landingPageValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
			},
			ModifiedNetlinkValidationObjects: {
				urlBoughtValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
				landingPageValidationObject: {
					valid: false,
					notValid: false,
					validText: null,
					errText: null,
					constraintName: "websiteConstraint",
					required: true
				},
			},
			validators: {},
			check: true,
			netlink_types: []
		};
	},
	created() {
		this.$store.dispatch("getAllNetlink");
		this.$store.dispatch("getAllDns");
	},
	async mounted() {
		//console.log("Check purchaseId", this.$props.purchaseId);
		await this.getAllNetlinkTypes();
		if(this.$props.purchaseId){
			//console.log("this.$props.purchaseId", this.$props.purchaseId);
			if(this.isEdit){
				this.checkPurchaseHaveNetlink();
			}
		}
		if(this.netlink_list && this.netlink_list.length > 0){
			this.totalLinkPrice = this.getPurchasePrice();
		}
	},
	updated(){
		if(this.netlink_list.length > 0){
			this.totalLinkPrice = this.getPurchasePrice();
		}
	},
	computed: {
		netlinks: () => {
			return store.state.netlink;
		},
		dns: () => {
			return store.state.dns;
		}
	},
	watch: {
		newAnchorType: function(){
			//console.log("newAnchorType");
			this.netlink.anchorType = this.newAnchorType;
		},
		newLandingPage: function(){
			//console.log("newLandingPage");
			this.netlink.landingPage = this.newLandingPage;
		},
		newUrlBought: function(){
			//console.log("newUrlBought");
			this.netlink.urlBought = this.newUrlBought;
		},
		newLinkType: function(){
			//console.log("newLinkType");
			this.netlink.linkType = this.newLinkType;
		},
		newLinkPrice: function(){
			//console.log("newLinkPrice");
			this.netlink.price = this.newLinkPrice;
		},
		newRenewDuration: function(){
			//console.log("newRenewDuration");
			this.netlink.renew_duration = this.newRenewDuration;
		},
		newStatus: function(){
			//console.log("newStatus");
			this.netlink.status = this.newStatus;
		},
		netlinks: function(){
			if(this.$props.isEdit && this.$props.purchaseId){
				this.checkPurchaseHaveNetlink();
			}
		},
		netlink_types: function(data){
			this.linkTypes = data.filter(row => row.is_dns == 0);
		},
		purchaseId: function(){
			//console.log("purchase_id updated");
			if(this.isEdit){
				this.checkPurchaseHaveNetlink();
			}
		},
		societyId: function(){
			//console.log("society_id updated");
			/*
			 *   if(!this.purchaseId){
			 *     //console.log("No purchase_id:", this.purchaseId)
			 *     this.netlink_list = this.netlinks.filter(netlink => netlink.society_id == this.$props.societyId)
			 *   }
			 */
		},
		netlink_list: function(){
			//console.log("netlink_list updated");
			this.totalLinkPrice = this.getPurchasePrice();
			this.$emit("netlink-update", this.netlink_list.length);
		},
	},
	methods: {
		getAllNetlinkTypes(){
			return new Promise((resolve, reject) => {
				this.$http.get(this.apiUrl + "netlink/type/all").then(res => {
					//console.log("getAllNetlinkTypes res.data", res.data);
					this.netlink_types = res.data;
					resolve(true);
				})
					.catch(e => {
						reject(e);
					});
			});
		},
		getNetlinkTypeName(netlinkTypeId){
			let foundNetlinkType = this.netlink_types.findIndex(row => row.id == netlinkTypeId);
			if(foundNetlinkType >= 0) return this.netlink_types[foundNetlinkType].name;
			else" ";
		},
		isRecurringLink(link_type){
			let foundIndex = this.netlink_types.findIndex(row => row.id == link_type);
			if(foundIndex >= 0){
				if(this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},
		getPurchasePrice(){
			let price = 0;
			// //console.log("getPurchasePrice")
			for(let i = 0; i < this.netlink_list.length; i++){
				// //console.log("this.netlink_list[i].price", this.netlink_list[i].price)
				price += parseFloat(this.netlink_list[i].price);
			}
			// //console.log("price", price)
			return price.toFixed(2);
		},
		getDnsName(dns_id){
			let foundDns = this.dns.find(d => d.id == dns_id);
			if(foundDns){
				return foundDns.host;
			}
			return "";
		},

		updateTotalPrice(price = null){
			if(price == null){
				this.$emit("update-total-price", this.totalPurchasePrice);
			}
			else{
				this.$emit("update-total-price", price);
			}
		},

		getNetlinkRenewDuration(renew_duration){
			//console.log("renew_duration", renew_duration);
			let foundRenewDuration = this.renewDurations.findIndex(rd => rd.value == renew_duration);
			//console.log("foundRenewDuration", foundRenewDuration);
			if(foundRenewDuration >= 0){
				return this.renewDurations[foundRenewDuration].text;
			}
			return "A\u00a0vie";
		},

		getNetlinkData(){
			return this.netlink;
		},

		getNetlinkListData(){
			return this.netlink_list;
		},

		showNewNetlinkForm(){
			this.showNewNetlink = true;
		},

		validateOne(val, name){
			let value = val;
			value === 0 ? value = "0" : "";
			let constname = "";
			switch(name){
			case"price":
			case"newLinkPrice":
				value ? value = String(val) : "";
				constname = "priceConstraint";
				break;
			case"newUrlBought":
			case"newLandingPage":
			case"urlBought":
			case"landingPage":
				constname = "websiteConstraint";
				break;
			default:
				value ? value = String(val) : "";
				value == null ? value = "" : "";
				constname = "isNumberConstraint";
				break;
			}
			this.validators[name] = new Validator({constraintName: constname});
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
			this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators && this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				return "display: inline-block; width: calc(100% - 30px) !important; border: 1px solid red !important; border-radius: 5px;";
			}
			else if(this.validators && this.validators[name] && this.validators[name].errText == ""){
				return "display: inline-block; border: 1px solid green !important; border-radius: 5px;";
			}
			else{
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},

		addNetLink(){
			this.check = true;
			let fields = ["newUrlBought", "newLandingPage", "newStatus", "newAnchorType", "newLinkType", "newLinkPrice", "newRenewDuration", "newNetlinkDns"];
			let fieldsVal = [this.newUrlBought, this.newLandingPage, this.newStatus, this.newAnchorType, this.newLinkType, this.newLinkPrice, this.newRenewDuration, this.newNetlinkDns];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = fieldsVal[i];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"newUrlBought":
				case"newLandingPage":
					constname = "websiteConstraint";
					break;
				case"newLinkPrice":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}

				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				fieldsVal[i] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "newRenewDuration" && !this.isRecurringLink(this.newLinkType)){
					this.newRenewDuration = null;
					this.validators[fields[i]].valid = true;
				}
				if(this.isFromNDD == 1){
					if(fields[i] == "newRenewDuration" || fields[i] == "newLinkType" || fields[i] == "newLinkPrice"){
						this.newRenewDuration = null;
						this.newLinkType = null;
						this.newLinkPrice = null;
						this.validators[fields[i]].valid = true;
					}
				}
				if(this.isFromNDD == 0){
					if(fields[i] == "newNetlinkDns"){
						this.newNetlinkDns = null;
						this.validators[fields[i]].valid = true;
					}
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";

			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				this.newLinkPrice = String(this.newLinkPrice).replace(",", ".");
				this.newLinkPrice = Number(this.newLinkPrice);

				/*
				 * if(this.$props.linkType){ // TODO Link type
				 *   //console.log(this.$props.linkType)
				 *   this.netlink.linkType = this.$props.linkType
				 * }
				 */
				this.netlink.status = 0; // Actif par défaut

				/*
				 * if(this.isFromNDD){
				 *   this.netlink.linkType = 3
				 * }
				 */

				if(!this.isRecurringLink(this.netlink.linkType)){
					this.netlink.renew_duration = null;
				}

				this.netlink.dns_id = this.newNetlinkDns ? this.newNetlinkDns : null;
				// //console.log("this.netlink", this.netlink)
				let newNetlink = new Netlink(this.netlink);
				this.netlink_list.push(newNetlink);
				newNetlink.price = this.newLinkPrice;
				this.totalPurchasePrice = this.totalPurchasePrice + this.newLinkPrice;
				this.updateTotalPrice(this.totalPurchasePrice); // TO REMOVE
				this.showNewNetlink = false;
			}
		},

		newNetlink(){

			if(!this.checkAllRequiredFields()){
				this.$vs.notify({
					title: "Echec",
					text: "Tous les champs nécessaires ne sont pas remplis."
				});
				return false;
			}
			if(!this.checkAllFieldsError()){
				this.$vs.notify({
					title: "Echec",
					text: "Certains champs contiennent une valeur erronée."
				});
				return false;
			}


			/*
			 * this.netlink.landingPage = this.netlink.landingPage;
			 * this.netlink.urlBought = this.netlink.urlBought;
			 */


			// //console.log("new url test",this.netlink.urlBought, this.netlink.landingPage )

			//console.log("this.$props.purchaseId", this.$props.purchaseId);
			if(this.$props.purchaseId){
				//console.log(this.$props.purchaseId);
				this.netlink.purchase_id = this.$props.purchaseId;
			}
			//console.log("this.$props.societyId", this.$props.societyId);
			if(this.$props.societyId){
				//console.log(this.$props.societyId);
				this.netlink.society_id = this.$props.societyId;
			}


			let newNetlink = new Netlink(this.netlink);
			//console.log(newNetlink);
			newNetlink.create((err, res) => {
				if(err) //console.log(err);
				if(res) {
					//console.log(res.data.insertId);
					this.$store.dispatch("getAllNetlink");
					newNetlink.id = res.data.insertId;
					this.netlink_list.push(newNetlink);
				}
			});
		},

		deleteNetlink(netlink){
			//console.log(netlink);
			this.netlink_list.splice(netlink, 1)
		},

		acceptDelete(){
			this.deleteNetlink(this.selectedNetlink);
			this.showValidationPopup = false;
		},

		declineDelete(){
			this.selectedNetlink = null;
			this.showValidationPopup = false;
		},

		displayValidationPopup(netlinkId){
			this.selectedNetlink = netlinkId;
			this.showValidationPopup = true;
		},

		modifyNetlink(netlinkIndex){
			//console.log(netlinkIndex);
			//Initialisation des données pour le popup
			this.modifiedNetlinkIndex = null; // Always reset data before assigning it
			this.modifiedNetlink = null; // Always reset data before assigning it
			this.modifiedNetlinkIndex = netlinkIndex; // Always reset data before assigning it
			this.modifiedNetlink = JSON.parse(JSON.stringify(this.netlink_list[netlinkIndex]));
			this.showNetlinkPopup = true;
		},
		saveModifiedNetlink(){
			this.check = true;
			let fields = ["urlBought", "landingPage", "status", "anchorType", "linkType", "price", "renew_duration"];
			let constname = "";

			for(let i = 0; i < fields.length; i++){
				let value = this.modifiedNetlink[fields[i]];
				value === 0 ? value = "0" : "";
				switch(fields[i]){
				case"urlBought":
				case"landingPage":
					constname = "websiteConstraint";
					break;
				case"price":
					value ? value = String(value) : "";
					constname = "priceConstraint";
					break;
				default:
					value ? value = String(value) : "";
					value == null ? value = "" : "";
					constname = "isNumberConstraint";
					break;
				}
				this.validators[fields[i]] = new Validator({constraintName: constname});
				this.validators[fields[i]].check(value);
				this.modifiedNetlink[fields[i]] == null ? this.validators[fields[i]].valid = false : "";
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText == "" ? this.validators[fields[i]].errText = "Ce champ ne peut être vide." : "";
				if(fields[i] == "renew_duration" && !this.isRecurringLink(this.modifiedNetlink.linkType)){
					this.modifiedNetlink.renew_duration = null;
					this.validators[fields[i]].valid = true;
				}
				if(this.isFromNDD == 1){
					if(fields[i] == "renew_duration" || fields[i] == "linkType" || fields[i] == "price"){
						this.modifiedNetlink.renew_duration = null;
						this.modifiedNetlink.linkType = null;
						this.modifiedNetlink.price = null;
						this.validators[fields[i]].valid = true;
					}
				}
				if(this.isFromNDD == 0){
					if(fields[i] == "newNetlinkDns"){
						this.newNetlinkDns = null;
						this.validators[fields[i]].valid = true;
					}
				}
				this.validators[fields[i]].valid == false && this.validators[fields[i]].errText !== "" ? this.check = false : "";
			}

			this.$forceUpdate();

			if(this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			else{
				/*
				 * if(!this.checkAllModifiedFieldsError()){
				 *   this.$vs.notify({
				 *     title: "Echec",
				 *     text: "Certains champs contiennent une valeur erronée."
				 *   });
				 *   return false
				 * }
				 * let params = {
				 *   id: this.modifiedNetlink.id,
				 *   urlBought: this.modifiedNetlink.urlBought,
				 *   anchorType: this.modifiedNetlink.anchorType,
				 *   landingPage: this.modifiedNetlink.landingPage,
				 *   status: this.modifiedNetlink.status,
				 *   linkType: this.modifiedNetlink.linkType,
				 *   domainAuthority: this.modifiedNetlink.domainAuthority,
				 *   pageAuthority: this.modifiedNetlink.pageAuthority,
				 *   trustFlow: this.modifiedNetlink.trustFlow,
				 *   citationFlow: this.modifiedNetlink.citationFlow,
				 *   externalLinks: this.modifiedNetlink.externalLinks,
				 *   refDomains: this.modifiedNetlink.refDomains,
				 *   purchase_id: this.modifiedNetlink.purchase_id,
				 *   society_id: this.modifiedNetlink.society_id,
				 *   dns_id: this.modifiedNetlink.dns_id,
				 *   contract_id: this.modifiedNetlink.contract_id,
				 * }
				 * //console.log("params")
				 */
				this.modifiedNetlink.price = String(this.modifiedNetlink.price).replace(",", ".");
				this.modifiedNetlink.price = Number(this.modifiedNetlink.price);
				this.totalPurchasePrice = this.totalPurchasePrice - this.netlink_list[this.modifiedNetlinkIndex].price + this.modifiedNetlink.price;
				this.isFromNDD == 1 ? this.totalPurchasePrice = 0 : "";
				this.netlink_list[this.modifiedNetlinkIndex] = new Netlink(this.modifiedNetlink);
				this.netlink_list[this.modifiedNetlinkIndex].price = this.modifiedNetlink.price;
				this.updateTotalPrice(this.totalPurchasePrice);

				/*
				 * let savedModifiedNetlink = new Netlink(params)
				 * //console.log(savedModifiedNetlink)
				 * savedModifiedNetlink.update((err, res) => {
				 *   if(err) //console.log(err)
				 *   if(res) {
				 *     //console.log(res)
				 *     this.netlink_list = this.netlink_list.map(nl => nl.id === this.modifiedNetlink.id ? this.modifiedNetlink : nl);
				 *     this.$store.dispatch("getAllNetlink");
				 */
				this.showNetlinkPopup = false;
				window.dispatchEvent(new Event("resize"));
				/*
				 *   }
				 * })
				 */
			}
		},
		checkPurchaseHaveNetlink(){
			let netlinksFiltered = this.netlinks.filter(netlink => netlink.purchase_id == this.$props.purchaseId);
			//console.log("checkPurchaseHaveNetlink");
			//console.log(this.$props.purchaseId);
			//console.log(this.netlinks);
			//console.log(netlinksFiltered);
			if(netlinksFiltered.length > 0){
				this.netlink_list = netlinksFiltered;
			}
		},

		checkSocietyHaveNetlink(){
			let netlinksFiltered = this.netlinks.filter(netlink => netlink.purchase_id == this.$props.purchaseId);
			//console.log("checkPurchaseHaveNetlink");
			//console.log(this.$props.purchaseId);
			//console.log(this.netlinks);
			//console.log(netlinksFiltered);
			if(netlinksFiltered.length > 0){
				this.netlink_list = netlinksFiltered;
			}
		},
	},
};
</script>
<style scoped>

</style>
